module.exports = __webpack_public_path__ + "static/media/RBC.03404873.png";